import { Component, Inject, OnInit } from '@angular/core';
import { LibraryType } from 'src/app/core/enums/regulator/regulator-status';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { RegulationService } from './../../../core/services/regulation/regulation.service';
import { PublishRegulationFilter, ReportFilterModel } from 'src/app/core/models/regulation/publish-regulation-model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { DateRangePickerComponent } from '../../shared/date-range-picker/date-range-picker.component';
import { FormControl, FormGroup } from '@angular/forms';
import { DateRangeView } from 'src/app/core/models/view-model/date-range-view-model';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-publish-report-dialog',
  templateUrl: './publish-report-dialog.component.html',
  styleUrls: ['./publish-report-dialog.component.scss']
})
export class PublishReportDialogComponent implements OnInit {

  reportFilter: ReportFilterModel;
  publishReportFilter: PublishRegulationFilter;
  libraries: ItemIdModel[] = [];
  isTitleErr = false;
  isHeadingErr = false;
  isLibraryErr = false;
  toastModel: ToastViewModel;
  isToastShow = false;
  datePickerGroup: FormGroup;
  dateRange: DateRangeView;
  isDateRange = false;


  constructor(private regulationService: RegulationService, private dialogRef: MatDialogRef<PublishReportDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: Array<number>) {
    this.publishReportFilter = new PublishRegulationFilter();
    this.reportFilter = new ReportFilterModel();
    this.toastModel = new ToastViewModel();
    this.dateRange = new DateRangeView();
    this.datePickerGroup = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
  }

  ngOnInit(): void {
    this.fetchRegulationLibrary();
    this.addReportFilter();
    this.publishReportFilter.selectedIdList = this.data;
  }


  fetchRegulationLibrary(): void {
    this.regulationService.getUserRegulationLibrary(LibraryType.Static).subscribe((data: Array<ItemIdModel>) => {
      this.libraries = data;
      const newLibrary = new ItemIdModel();
      newLibrary.id = 0;
      newLibrary.name = 'Selection';

      this.libraries.unshift(newLibrary);
    });
  }

  removeReportFilter(tComponent: ReportFilterModel): void {
    tComponent.isDeleted = true;
    const index = this.publishReportFilter.reportFilter.indexOf(tComponent);
    if (index >= 0) {
      this.publishReportFilter.reportFilter.splice(index, 1);
    }
  }

  addReportFilter(): void {
    this.reportFilter.isDeleted = false;
    this.publishReportFilter.reportFilter.push(new ReportFilterModel());
  }

  publishReport(): void {
    this.isTitleErr = false;
    this.isHeadingErr = false;
    this.isLibraryErr = false;
    if (!this.isDateRange) {
      this.publishReportFilter.startDate = MasterHelper.getDate(90);
      this.publishReportFilter.endDate = MasterHelper.getDate(0);
    }
    if (!this.publishReportFilter.title) {
      this.isTitleErr = true;
      setTimeout(() => {
        this.isTitleErr = false;
      }, 3000);
    } else if (this.publishReportFilter.reportFilter.length === 0) {
      this.isHeadingErr = true;
      setTimeout(() => {
        this.isHeadingErr = false;
      }, 3000);
    } else if (this.publishReportFilter.reportFilter.length > 0 && !this.publishReportFilter.reportFilter[0].header) {
      this.isHeadingErr = true;
      setTimeout(() => {
        this.isHeadingErr = false;
      }, 3000);
    } else if (this.publishReportFilter.reportFilter.length > 0 && this.publishReportFilter.reportFilter[0].libraries.length === 0) {
      this.isLibraryErr = true;
      setTimeout(() => {
        this.isLibraryErr = false;
      }, 3000);
    }
    else {
      this.dialogRef.close(this.publishReportFilter);
    }
  }
  onSelectLibrary(event: Array<ItemIdModel>, row: number) {
    length = event.length - 1;
    if (length > -1 && event[length].id === 0 && this.publishReportFilter.selectedIdList.length == 0) {
      this.publishReportFilter.reportFilter[row].libraries = event.filter(e => e.id !== 0);
      this.warningAlert("Please select regulation if you want to select the selection option");
    }
  }
  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  onChangeDateRange(event: any): void {
    if (event.target.value) {
      this.isDateRange = true;
      this.publishReportFilter.startDate = this.dateRange.startDate;
      this.publishReportFilter.endDate = this.dateRange.endDate;
    }
  }

}
